import { Modal, Button } from "react-bootstrap";
import React from "react";
import { AiOutlineClose, AiOutlineWarning } from "react-icons/ai";

const WarningModal = ({
  showModal,
  modalClose,
  setConfirmClose,
  text,
  confirmDisabled,
  confirmLabel,
}) => {
  return (
    <Modal
      show={showModal}
      onHide={modalClose}
      centered
      backdrop="static"
      contentClassName="rounded-3 shadow-lg border-0"
    >
      <Modal.Header className="border-0 pb-0 pt-2 ps-3 pe-2 position-relative justify-content-center">
        <button
          type="button"
          className="position-absolute btn btn-light border-0 rounded-circle d-flex align-items-center justify-content-center p-0 text-secondary shadow-sm"
          style={{
            top: "8px",
            right: "8px",
            width: "30px",
            height: "30px",
            lineHeight: 1,
          }}
          onClick={modalClose}
          aria-label="Close"
        >
          <AiOutlineClose size={18} />
        </button>
        <Modal.Title className="w-100 mb-0 text-center text-danger fw-bold">
          <span className="d-inline-flex align-items-center justify-content-center gap-2">
            <AiOutlineWarning size={22} />
            Warning
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center px-4 pb-4">
        <p className="mb-3 text-center fs-6 text-muted">{text}</p>
        <div className="gap-2 d-flex align-items-center justify-content-center">
          <Button
            className="grey-btn"
            onClick={setConfirmClose}
            disabled={confirmDisabled}
          >
            {confirmLabel ?? "Confirm"}
          </Button>
          <Button className="red-btn" onClick={modalClose}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WarningModal;
